var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeeper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6034_33627)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1218 3.27325H11.6666V9.51527H14.8575L18.696 6.46317L19.6607 7.66821L15.3989 11.0564H10.1218V3.27325Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1438 3.48366L14.6887 3.87694V6.03492L16.4173 4.61811L17.7008 5.56097L14.407 8.26013L13.1438 8.25341V3.48366Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0387 15.0849L5.58354 16.3958V7.81427L4.0387 9.22772V15.0849Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61257 18.2411L7.06604 19.5806V4.49485L8.61257 5.83434V18.2411Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6887 18.1174L16.4173 19.5342L17.7008 18.5897L14.407 15.8922L13.1438 15.8989V20.6687L14.6887 20.2754V18.1174Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.696 17.4786L14.8575 14.4248H11.6666V20.6668H10.1218V12.8853H15.3989L19.6607 16.2735L18.696 17.4786Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7376 11.9706L19.8981 14.5706L20.883 13.3823L19.1661 11.9706L20.883 10.5588L19.8981 9.37056L16.7376 11.9706Z",
    fill: "#FFC700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6034_33627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeeper);
export default __webpack_public_path__ + "static/media/Keeper.d2a969dbedb081a2cbfaa95e6248aefe.svg";
export { ForwardRef as ReactComponent };